import Raven from "raven-js";

export default () => {
  if (process.env.NODE_ENV === "production") {
    Raven.config(process.env.REACT_APP_SENTRY_KEY).install();
  }
};



// WEBPACK FOOTER //
// ./src/core/integrations/sentry/init.js